import { gql } from '@apollo/client';

export const configureRewards = gql`
  mutation configureRewards($rewardConfiguration: RewardTiersConfiguration!, $thresholdsEnabled: Boolean!, $fiveStarRewards: Boolean!) {
    configureRewards(input: { rewardConfiguration: $rewardConfiguration, thresholdsEnabled: $thresholdsEnabled, fiveStarRewards: $fiveStarRewards })
  }
`;
